export const CSS_EASE = {
  outExpo: 'cubic-bezier(0.16, 1, 0.3, 1)',
  settle: 'cubic-bezier(0.2, 0.9, 0.25, 1)',
  press: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
};

export const EASE_FN = {
  inOutCubic: (t: number) => (t < 0.5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2),
};

export const DURATION = { reveal: 700, hover: 160, press: 120 };
